import {
  LAYER_TEMPLATE_FETCH_REQUEST,
  LAYER_TEMPLATE_FETCH_SUCCESS,
  LAYER_TEMPLATE_FETCH_FAILURE,
  LAYER_TEMPLATE_CREATE_SUCCESS,
  LAYER_TEMPLATE_UPDATE_SUCCESS,
  LAYER_TEMPLATE_DELETE_SUCCESS,
} from "../types/layerTemplateTypes";

const initialState = {
  loading: false,
  list: [],
  error: null,
};

const layerTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case LAYER_TEMPLATE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case LAYER_TEMPLATE_FETCH_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };

    case LAYER_TEMPLATE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case LAYER_TEMPLATE_CREATE_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };

    case LAYER_TEMPLATE_UPDATE_SUCCESS:
      return {
        ...state,
        list: state.list.map((t) =>
          t.id === action.payload.id ? action.payload : t
        ),
      };

    case LAYER_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        list: state.list.filter((t) => t.id !== action.payload),
      };

    default:
      return state;
  }
};

export default layerTemplateReducer;
